import { createRef } from 'react'

export default class CookieAgree extends React.Component {
  constructor() {
    super()
    const agreedMillis = Helpers.getCookie('cookieAgreed') || false
    // Ensure previous agreement was less than 1 calendar year ago
    const oneYearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getTime()
    this.agreed = agreedMillis && (parseFloat(agreedMillis) > oneYearAgo)
    this.elementRef = createRef(null)
  }

  render () {
    if (this.props.enabled && this.agreed === false) {
      return (
        <div id='toast-container' className='toast-bottom-center'>
          <div className='container px-3'>
            <div className='toast' ref={this.elementRef}>
              <h2 className='toast-title'>{I18n.t('layouts.support.cookie_agree_title')}</h2>
              <div className='toast-message'>
                <p>{I18n.t('layouts.support.cookie_agree_message')}</p>
              </div>
              {/* <div className='pointer collapsed link-dashed-span' data-bs-toggle="collapse" data-target="#collapseExample">
                <span>{I18n.t('layouts.support.privacy_terms_link')}</span>
                <div className='expander pull-right' />
              </div> */}
              <div className='bg-primary px-4 py-3 mx-n4 mt-3 flex flex-md-row flex-column small' id='collapseExample'>
                <div>
                  <h4 className='flex align-items-center'><i className='fa fa-cog fa-lg me-2' /> {I18n.t('layouts.support.cookie_agree_options.strict')}</h4>
                  <div>{I18n.t('layouts.support.cookie_agree_hints.strict')}</div>
                </div>
                <div style={{ width: '2rem', height: '1rem' }} />
                <div>
                  <h4 className='flex align-items-center'><i className='fa fa-poll fa-lg me-2' /> {I18n.t('layouts.support.cookie_agree_options.marketing')}</h4>
                  <div>{I18n.t('layouts.support.cookie_agree_hints.marketing')}</div>
                </div>
              </div>
              <div className='toast-footer flex align-items-center'>
                <a href='/terms' className='' target='_blank'>{I18n.t('privacy')}</a> <i className='fa fa-external-link-alt ms-2' />
                <button
                  type='button' className='btn-light btn ms-auto'
                  onClick={this.agree.bind(this, 1)}
                >{I18n.t('layouts.support.cookie_agree_actions.marketing')}
                </button>
                <button
                  type='button' className='btn-link btn'
                  onClick={this.agree.bind(this, 0)}
                >{I18n.t('layouts.support.cookie_agree_actions.strict')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  agree (acceptAll) {
    Helpers.setCookie('cookieAgreed', new Date().getTime(), 365)
    Helpers.setCookie('allCookieAgreed', acceptAll ? 1 : 0, 365)
    $(this.elementRef.current).fadeOut()
  }
}

CookieAgree.propTypes = {
  enabled: PropTypes.bool
}
